<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="q-pa-md">
    <q-stepper
      v-model="step"
      v-if="order"
      color="primary"
      style="margin-bottom: -100px;"
      flat
      alternative-labels >
      <q-step
        :name="1"
        title="Placed"
        :caption="formatDate(order.placed)"
        icon="where_to_vote"
        :done="step >= 1"
      />

      <q-step
        :name="2"
        :title="`Container Close${(step >= 2) ? 'd' : 's'}`"
        :caption="`${formatDate(((order||{}).groupOrder||{}).closeDate)} (${fromNow(((order||{}).groupOrder||{}).closeDate)})`"
        icon="gavel"
        :done="step >= 2"
      />

      <q-step
        :name="3"
        :title="`Manufactur${(step > 3) ? 'ed' : 'ing'}`"
        :caption="(step > 3) ? `Finished ${formatDate((order||{}).processed)}` : `~${monthsToManufacture} months`"
        icon="build"
        active-icon="schedule"
        :done="(step > 3)"
      />

      <q-step
        :name="4"
        title="Shipping"
        :caption="`~${monthsToShip} months`"
        icon="directions_boat"
        active-icon="schedule"
        :done="step > 4"
      />

      <q-step
        :name="5"
        title="Delivered"
        :caption="(order||{}).delivered ? `${formatDate((order||{}).delivered)}` : `Estimated ${formatMonth(deliveryDateEstimate)}`"
        icon="cake"
        active-icon="cake"
        :done="step >= 5"
      />

      <template v-slot:navigation>
      </template>
    </q-stepper>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { formatDateTime, formatDate, formatMonth, fromNow } from '../util/string'
import moment from 'moment'

export default {
  name: 'PlacedOrderContainerTimeline',
  props: ['orderId'],
  apollo: {
    order () {
      return {
        query: gql`
          query containerOrder ($id: ID!){
            containerOrder (id: $id ){
              id
              name
              placed
              processed
              leftManufacturer
              delivered
              groupOrder {
                id
                name
                isOpen
                closeDate
              }
            }
          }
        `,
        variables () {
          return {
            id: this.orderId
          }
        },
        update (result) {
          if (result.containerOrder?.placed) this.step = 1
          if (!result.containerOrder?.groupOrder?.isOpen) this.step = 3
          if (result.containerOrder?.processed) this.step = 3.5
          if (result.containerOrder?.leftManufacturer) this.step = 4
          if (result.containerOrder?.delivered) this.step = 5
          return result.containerOrder
        }
      }
    }
  },
  computed: {
    deliveryDateEstimate () {
      return moment(this.order.groupOrder.closeDate)
        .add(this.monthsToManufacture + this.monthsToShip, 'M') // The 'M' is for months, eg. 5 months.
    }
  },
  methods: {
    formatDateTime,
    formatDate,
    formatMonth,
    fromNow
  },
  data () {
    return {
      monthsToManufacture: 3,
      monthsToShip: 2,
      step: 1,
      shownStep: 0
    }
  }
}
</script>

<style scoped>

</style>
